import { render, staticRenderFns } from "./TypePaymentInsurance.vue?vue&type=template&id=28475957&scoped=true&"
import script from "./TypePaymentInsurance.ts?vue&type=script&lang=ts&"
export * from "./TypePaymentInsurance.ts?vue&type=script&lang=ts&"
import style0 from "./TypePaymentInsurance.vue?vue&type=style&index=0&id=28475957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28475957",
  null
  
)

export default component.exports